'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CodeSplitEnvWrapper = require('pricing-pages-unified-ui/components/CodeSplitEnvWrapper');

var _CodeSplitEnvWrapper2 = _interopRequireDefault(_CodeSplitEnvWrapper);

var _Tracking = require('pricing-pages-unified-ui/constants/Tracking');

var _MerchandiseIdsToUpgradeProducts = require('self-service-api/constants/MerchandiseIdsToUpgradeProducts');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MerchCardCTAsContainer = function MerchCardCTAsContainer(props) {
  // TODO: Gotta figure out how to properly get props through
  // TODO: https://product.hubteam.com/docs/frontend/changes/code-splitting.html
  return _react2.default.createElement(_CodeSplitEnvWrapper2.default, {
    authedComponentLoader: function authedComponentLoader() {
      return import( /* webpackChunkName: "authed-chunk" */'pricing-pages-unified-ui/components/product-pages/MerchCardAuthedCTAs');
    },
    publicComponentLoader: function publicComponentLoader() {
      return import( /* webpackChunkName: "public-chunk" */'pricing-pages-unified-ui/components/public-only/PublicPurchaseMotionButton');
    },
    authedComponentProps: _extends({}, props),
    publicComponentProps: {
      merchandiseId: props.merchandiseId,
      sourceId: 'pricing-hero',
      dtbSource: 'pricing-page|' + props.hub + '-hub|' + _Tracking.MERCH_CARD + '|' + _MerchandiseIdsToUpgradeProducts.MerchandiseIdsToUpgradeProducts[props.merchandiseId]
    }
  });
};

exports.default = MerchCardCTAsContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/product-pages/MerchCardCTAsContainer.js
// module id = 759
// module chunks = 3 4